import LanguageButton from "../elements/lang-toggle";
import { useSelector } from "react-redux";
import { selectCurrentRoom } from "@/context/features/room/roomSlice";
import { selectCurrentAuth } from "@/context/features/auth/authSlice";
import Addpatient from "../modules/patients/add-patient";
import Logo from "../elements/logo";
import { useIsMobile } from "@/hooks/responsive/useIsMobile";
import { Popover, PopoverContent, PopoverTrigger } from "../ui/popover";
import { ModeToggle } from "../elements/mode-toggle";
import ReturnToPrescription from "../elements/return-to-prescription";
import RoleOnly from "@/components/elements/role-only";

const Header = () => {
  const { isInMeet } = useSelector(selectCurrentRoom);
  const { user } = useSelector(selectCurrentAuth);
  const isMobile = useIsMobile();

  return (
    <header className="px-2 sm:px-4 h-14 py-2 border-b flex items-center">
      <div className="w-full flex items-center gap-1 sm:gap-3">
        <Logo variant="withText" isDefault={true} isMobile={isMobile} />

        {/* middle: title area that can shrink */}
        <div className="flex-1 min-w-0">
          {isInMeet &&
            (!isMobile ? (
              <h3
                className="text-sm text-foreground font-semibold truncate min-w-0"
                title={user?.session_name || ""}
              >
                {user?.session_name}
              </h3>
            ) : (
              <Popover>
                <PopoverTrigger asChild>
                  <button
                    className="flex w-full items-center gap-0.5 px-2 py-1 rounded-md text-foreground min-w-0"
                    title={user?.session_name || ""}
                  >
                    {/* <Info className="shrink-0" /> */}
                    <span className="truncate min-w-0 font-semibold flex-1">
                      {user?.session_name}
                    </span>
                  </button>
                </PopoverTrigger>

                <PopoverContent
                  className="max-w-[60vw] p-3 mx-2"
                  side="bottom"
                  align="start"
                >
                  <span className="text-sm break-words text-foreground font-semibold">
                    {user?.session_name}
                  </span>
                </PopoverContent>
              </Popover>
            ))}
        </div>

        {/* right-side controls shouldn't shrink */}
        <div className="shrink-0 flex gap-2">
          <RoleOnly extraCondition={isInMeet}>
            <Addpatient />
          </RoleOnly>
          <ReturnToPrescription />
        </div>
        <div className="shrink-0 ms-2 flex items-center gap-1">
          <ModeToggle />
          <LanguageButton />
        </div>
      </div>
    </header>
  );
};

export default Header;
